import React from 'react';

import { ChildrenProps } from '../../../utils';
import { BannerType } from '../Banner/Banner';
import { Banner } from '../index';

type Props = ChildrenProps;

const BannerInfo = ({ children }: Props) => {
  return (
    <>
      <Banner type={BannerType.INFO}>{children}</Banner>
    </>
  );
};

export default BannerInfo;
